import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isChangePasswordRequestFailure() {
      return getState().request.isFailure;
    },
    isChangePasswordRequestPending() {
      return getState().request.isPending;
    },
    isChangePasswordRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getChangePasswordError() {
      return getState().error;
    },
  };
}

export { createSelector };
